import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

/**
 * Splits a string into an array of strings each being a line
 * @param {string} text
 * @returns {array} array of multiple lines
 * @see {https://attacomsian.com/blog/javascript-flatten-array}
 * @example intoLines("MultiLineText\n\nThis is another line\n\nAnd another\nOneMore")
 */
const intoLines = text => {
	// When someone enters 2 linebreaks in a row
	const splitInParagraphs = text.split("\n\n");
	const cleanParagraphs = splitInParagraphs.map(p => p.trim());
	// This will give us arrays in arrays but will fully split the lines
	const considerInnerLines = cleanParagraphs.map(l => l.split("\n"));
	// With this we flatten the array into a single one to map on react land
	return [].concat(...considerInnerLines);
};

/**
 * MultilineText
 *
 * @param {string} text - Text to be split in multiple lines
 */
const MultilineText = ({ text }) => (
	<Fragment>
		{intoLines(text).map((line, i, lines) => (
			<Fragment key={`line-${i}`}>
				{line}
				{i !== (lines.length - 1) && <br />}
			</Fragment>
		))}
	</Fragment>
);

MultilineText.propTypes = {
	text: PropTypes.string.isRequired,
};

MultilineText.defaultProps = {};

export default MultilineText;
